import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import styles from './NotFoundPage.module.scss';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <h1 className={styles.code}>404</h1>
        <p className={styles.message}>{t('error.notFound')}</p>
        <Link to="/" className={styles.btn}>
          {t('common.backToDashboard')}
        </Link>
      </div>
    </div>
  );
}
